module.exports = __webpack_public_path__ + "static/media/dqassessment-banner.e8cb3351.png";